import { useNode } from "@craftjs/core";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { Switch } from "@/components/shared/switch";

export const ImageAndTextWithButtonTwoColumnsSettings = () => {
  const { showCTA, actions } = useNode((node) => ({
    showCTA: node.data.props?.showCTA ?? "",
  }));
  const { t } = useTranslation();

  const handleSwitchToggle = useCallback(
    (checked: boolean) =>
      actions.setProp((props) => {
        props.showCTA = checked;
      }),
    [actions]
  );

  return (
    <section className="flex h-full flex-col gap-y-6 p-4">
      <div className="mt-2 flex items-center justify-between">
        <span className="flex items-center justify-start gap-x-2">
          <span className="text-sm">{t("content-hub.show-cta")}</span>
        </span>
        <Switch
          label={t("content-hub.show-cta")}
          defaultChecked={showCTA}
          onChange={handleSwitchToggle}
        />
      </div>
    </section>
  );
};
